module.exports = "/static/images/river-access.png";